import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../hooks/useAuth';
import { useFirebase } from '../../../hooks/useFirebase';
import { queryGet } from '../../tools/tools';

const toIsoFrom = (date) => (date ? `${date}T00:00:00` : null);
const toIsoTo = (date) => (date ? `${date}T23:59:59` : null);

export const useConsultantReports = (from, to) => {
  const { user } = useAuth();
  const { remoteConfig } = useFirebase();

  const params = new URLSearchParams();
  if (from) params.append('from', toIsoFrom(from));
  if (to) params.append('to', toIsoTo(to));
  const query = params.toString() ? `?${params}` : '';

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['sales-report-consultants', from, to, user?.uid],
    queryFn: () => queryGet(remoteConfig, `/sales/reports/consultants${query}`, user?.accessToken),
    enabled: !!user?.accessToken && !!remoteConfig
  });

  return { report: data ?? [], isLoading, isError, refetch };
};

export const useCouponReport = (from, to) => {
  const { user } = useAuth();
  const { remoteConfig } = useFirebase();

  const params = new URLSearchParams();
  if (from) params.append('from', toIsoFrom(from));
  if (to) params.append('to', toIsoTo(to));
  const query = params.toString() ? `?${params}` : '';

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['sales-report-coupons', from, to, user?.uid],
    queryFn: () => queryGet(remoteConfig, `/sales/reports/coupons${query}`, user?.accessToken),
    enabled: !!user?.accessToken && !!remoteConfig
  });

  return { report: data ?? [], isLoading, isError, refetch };
};
